import React from 'react';
import PropTypes from 'prop-types';
import {
  injectIntl,
  intlShape,
} from 'react-intl';
import classNames from 'classnames';
import { IconAuthMessage } from 'components/icons/icon-auth-message/icon-auth-message';
import { IconAuthTelegram } from 'components/icons/icon-auth-telegram/icon-auth-telegram';
import { IconAuthPhone } from 'components/icons/icon-auth-phone/icon-auth-phone';
import { FormattedTag } from 'core/components';

const ContactLinksUI = ({ intl: { formatMessage }, className }) => (
  <div
    className={classNames('form-sign-in-contact-links-container d-flex align-items-center justify-content-between bg-dark-2 p-1_5', className)}
  >
    <FormattedTag
      id="contact-links.title"
      className="text-gray-40 font-weight-semi-bold"
    />
    <div className="d-flex">
      <a
        href={formatMessage({ id: 'sign-in.contact.url.1', defaultMessage: 'none' })}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconAuthPhone />
      </a>

      <a
        href={formatMessage({ id: 'sign-in.contact.url.2', defaultMessage: 'none' })}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-0_5"
      >
        <IconAuthTelegram />
      </a>

      <a
        href={formatMessage({ id: 'sign-in.contact.url.3', defaultMessage: 'none' })}
        target="_blank"
        rel="noopener noreferrer"
        className="ml-0_5"
      >
        <IconAuthMessage />
      </a>
    </div>
  </div>
);

ContactLinksUI.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

ContactLinksUI.defaultProps = {
  className: '',
};

export const ContactLinks = injectIntl(ContactLinksUI);
